const info = {
  ZH: { //中文翻译

    title: " \u5F15\u7528\u6807\u51C6",
    selectednorm: " \u8BF7\u9009\u62E9\u4E00\u4E2A\u6807\u51C6\uFF01",
    submit: " \u786E\u5B9A",
    back: " \u53D6\u6D88",
    normInitials: " \u6807\u51C6\u9996\u5B57\u6BCD",
    findCondition: " \u8BF7\u8F93\u5165\u67E5\u8BE2\u6761\u4EF6",
    code: " \u6807\u51C6\u53F7",
    saveCondition: " \u4FDD\u7559\u8BB0\u5F55",
    inputCode: " \u8BF7\u8F93\u5165\u6807\u51C6\u53F7\uFF01",
  },
  EN: { //英文翻译
    title: " The quoted standards",
    selectednorm: " Please select norm\!",
    submit: " OK",
    back: " Cancel",
    normInitials: " Norm Initials",
    findCondition: " Please Enter A Query",
    code: " Code",
    saveCondition: " Record Keeping",
    inputCode: " Please enter code\!",
  }
}
export default info //需要暴露出去
